"use client";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import { useEffect } from "react";
import i18n from "i18next";

const InitI18n = () => {
  useEffect(() => {
    i18n
      .use(initReactI18next)
      .use(LanguageDetector)
      .use(HttpApi)
      .init({
        supportedLngs: ["en", "ar"],
        fallbackLng: {
          default: ["en"],
          ar: ["ar"],
          en: ["en"],
        },
        detection: {
          order: ["cookie", "localStorage", "path", "subdomain", "htmlTag"],
          caches: ["cookie"],
        },

        backend: {
          loadPath: "/assets/{{lng}}/translation.json",
        },

        react: { useSuspense: false },

        interpolation: {
          escapeValue: false,
        },
      });
  }, []);
  return <></>;
};

export default InitI18n;
